export const onboardingConstants = {
  NIC_VALIDATE_REQUEST: "NIC_VALIDATE_REQUEST",
  NIC_VALIDATE_COMPLETE: "NIC_VALIDATE_COMPLETE",
  NIC_VALIDATE_ERROR: "NIC_VALIDATE_ERROR",
  ONBOARDING_CLEAR_FORM_DATA: "ONBOARDING_CLEAR_FORM_DATA",
  ONBOARDING_TRY_AGAIN_FLOW: "ONBOARDING_TRY_AGAIN_FLOW",
  ONBOARDING_CLEAR_FORM_RESPONSE_DATA: "ONBOARDING_CLEAR_FORM_RESPONSE_DATA",

  ASSIGN_REGISTRATION_TYPE: "ASSIGN_REGISTRATION_TYPE",

  ALTERNATIVE_FLOW_ASSIGN_REGISTRATION_TYPE:
    "ALTERNATIVE_FLOW_ASSIGN_REGISTRATION_TYPE",

  ASSIGN_VERIFICATION_TYPE: "ASSIGN_VERIFICATION_TYPE",

  NIC_PASSPORT_VALIDATION_STEP: "NIC_PASSPORT_VALIDATION_STEP",

  SELECT_REGISTRATION_OPTION_STEP: "SELECT_REGISTRATION_OPTION_STEP",

  REGISTRATION_OPTION_CREDIT_CARD: "CREDIT_CARD",
  REGISTRATION_OPTION_DEBIT_CARD: "DEBIT_CARD",
  REGISTRATION_OPTION_CASA_ACCOUNT: "CASA",
  REGISTRATION_OPTION_SAVINGS: "SAVING",
  REGISTRATION_OPTION_FIXED_DEPOSITS: "DEPOSITS",
  REGISTRATION_OPTION_LENDING: "LENDING",
  REGISTRATION_OPTION_PAWNING: "PAWNING",

  ONBOARDING_ACCOUNT_NUMBER_MAX_LENGTH: 12,
  ONBOARDING_LENDING_ACCOUNT_MIN_LENGTH: 8,
  ONBOARDING_NUMERIC_ACCOUNT_MIN_LENGTH: 10,
  ONBOARDING_FD_ACCOUNT_MIN_LENGTH: 1,

  ACCOUNT_TYPE_FD: "FD",
  ACCOUNT_TYPE_CASA: "CASA",

  ONBOARDING_USERNAME_STEP: "ONBOARDING_USERNAME_STEP",

  ONBOARDING_PASSWORD_STEP: "ONBOARDING_PASSWORD_STEP",

  ONBOARDING_DISPLAY_NAME_STEP: "ONBOARDING_DISPLAY_NAME_STEP",

  NOT_A_LOLC_CUSTOMER_PAGE: "NOT_A_LOLC_CUSTOMER_PAGE",

  DEBIT_CARD_PRE_REGISTER_REQUEST: "DEBIT_CARD_PRE_REGISTER_REQUEST",
  DEBIT_CARD_PRE_REGISTER_COMPLETE: "DEBIT_CARD_PRE_REGISTER_COMPLETE",
  DEBIT_CARD_PRE_REGISTER_ERROR: "DEBIT_CARD_PRE_REGISTER_ERROR",

  DEBIT_CARD_INIT_REGISTER_REQUEST: "DEBIT_CARD_INIT_REGISTER_REQUEST",
  DEBIT_CARD_INIT_REGISTER_COMPLETE: "DEBIT_CARD_INIT_REGISTER_COMPLETE",
  DEBIT_CARD_INIT_REGISTER_ERROR: "DEBIT_CARD_INIT_REGISTER_ERROR",

  ONBOARDING_OTP_RESEND_REQUEST: "ONBOARDING_OTP_RESEND_REQUEST",
  ONBOARDING_OTP_RESEND_COMPLETE: "ONBOARDING_OTP_RESEND_COMPLETE",
  ONBOARDING_OTP_RESEND_ERROR: "ONBOARDING_OTP_RESEND_ERROR",

  ONBOARDING_OTP_CONFIRM_REQUEST: "ONBOARDING_OTP_CONFIRM_REQUEST",
  ONBOARDING_OTP_CONFIRM_COMPLETE: "ONBOARDING_OTP_CONFIRM_COMPLETE",
  ONBOARDING_OTP_CONFIRM_ERROR: "ONBOARDING_OTP_CONFIRM_ERROR",

  ONBOARDING_FLOW_ACCEPTED: "ACCEPTED",
  ONBOARDING_FLOW_PENDING: "PENDING",
  ONBOARDING_FLOW_DECLINED: "DECLINED",

  USERNAME_VALIDATE_REQUEST: "USERNAME_VALIDATE_REQUEST",
  USERNAME_VALIDATE_COMPLETE: "USERNAME_VALIDATE_COMPLETE",
  USERNAME_VALIDATE_ERROR: "USERNAME_VALIDATE_ERROR",

  VERIFICATION_OPTION_CALL_CENTER: "CALL_CENTER",

  VERIFICATION_OPTION_VISIT_BRANCH: "VISIT_BRANCH",

  SELECT_VERIFICATION_OPTION_STEP: "SELECT_VERIFICATION_OPTION_STEP",

  BACKOFFICE_VALIDATION_REQUEST: "BACKOFFICE_VALIDATION_REQUEST",
  BACKOFFICE_VALIDATION_COMPLETE: "BACKOFFICE_VALIDATION_COMPLETE",
  BACKOFFICE_VALIDATION_ERROR: "BACKOFFICE_VALIDATION_ERROR",

  VERIFICATION_IN_PROGRESS_STEP: "VERIFICATION_IN_PROGRESS_STEP",

  STORE_PROFILE_WIZARD_DETAILS: "STORE_PROFILE_WIZARD_DETAILS",

  PROCESS_SUCCESSFUL_STEP: "PROCESS_SUCCESSFUL_STEP",
  PROCESS_UNSUCCESSFUL_STEP: "PROCESS_UNSUCCESSFUL_STEP",

  ADD_PROFILE_INFO_REQUEST: "ADD_PROFILE_INFO_REQUEST",
  ADD_PROFILE_INFO_COMPLETE: "ADD_PROFILE_INFO_COMPLETE",
  ADD_PROFILE_INFO_ERROR: "ADD_PROFILE_INFO_ERROR",

  CREDIT_CARD_NUMBER: "Credit Card Number",
  CARD_ACCOUNT_NUMBER: "Card Account Number",

  CLEAR_VALIDATE_USERNAME_DATA: "CLEAR_VALIDATE_USERNAME_DATA",

  FIELD_NAME_CREDIT_CARD_NUMBER: "cardNumber",
  FIELD_NAME_CREDIT_EXP_DATE: "expDate",

  STORE_CURRENT_STEP: "STORE_CURRENT_STEP",

  FIELD_NAME_ONBOARDING_PASSPORT_NUMBER: "passportNumber",

  REMOVE_OWN_FORM_DATA_FIELDS: "REMOVE_OWN_FORM_DATA_FIELDS",
};
